import util from '../util'

let controller = 'protesto-boleto'

export default Object.assign({}, util.GetCrud(controller, null), {
  SolicitarProtesto: numCodBarrasList => {
    return util.Axios.Post(controller + '/solicitar', numCodBarrasList)
  },
  CancelarProtesto: function (numCodBarras) {
    return util.Axios.Post(controller + '/cancelar', numCodBarras)
  },
  SolicitarAnuencia: function (numCodBarras) {
    return util.Axios.Post(controller + '/informar-anuencia', numCodBarras)
  },
  SolicitarDesistencia: function (numCodBarras) {
    return util.Axios.Post(controller + '/informar-desistencia', numCodBarras)
  },
  ObterLiquidados: function (model, search, options) {
    let dto = {
      parameters: []
    }

    if (options && options.data) dto.data = options.data

    if (!(model.codBarras && model.codBarras !== '')) {
      dto.parameters.push({
        name: 'documentoPagador',
        value: model.documentoPagador
      })
      dto.parameters.push({ name: 'nomePagador', value: model.nomePagador })
      dto.parameters.push({ name: 'dtVencimento', value: model.dtVencimento })
      dto.parameters.push({ name: 'seuNumero', value: model.seuNumero })
      dto.parameters.push({ name: 'nossoNumero', value: model.nossoNumero })

      if (model.codigoCedente && model.codigoCedenteCarteira) {
        dto.parameters.push({
          name: 'codigoCedenteCarteira',
          value: model.codigoCedenteCarteira.value
        })
      }

      if (model.dtVencimentoFinal) {
        dto.parameters.push({
          name: 'dtVencimentoFinal',
          value: model.dtVencimentoFinal
        })
      }
    }

    dto.parameters.push({ name: 'codBarras', value: model.codBarras })

    dto.parameters.push({ name: 'filter', value: search })

    return util.Axios.GetAll(controller + '/Liquidados', dto)
  },
  ConciliarValores: dto => {
    return util.Axios.Post(controller + '/ConciliarValores', dto)
  },
  DownloadArquivoHistoricoBoletoProtestado: function (codigoDeBarras) {
    return util.Axios.Get(
      controller + `/arquivo-historico-boleto-protestado/${codigoDeBarras}`
    )
  },
  DownloadArquivoInstrumentoProtesto: function (numCodBarras) {
    return util.Axios.Get(
      controller + `/Instrumento/${numCodBarras}`
    )
  }
})
